export default "__VITE_ASSET__BD6ku73W__"